import React from "react";
import "./clinicTiming/clinicTiming.css"
import { t } from "../../Utils/translate";

function EditTimingPopupWarning({
    editTimingWarningMsg,
    futureAppointment,
    appointmentTotalCount,
    appointmentCount,
    appointmentRequestedCount,
    appointmentPatientCount,
}) {
    return (
        <div className="warning-appointment-main">
            <span>{editTimingWarningMsg} </span><br />
            <span>{futureAppointment}</span>
            <div className="warning-appointment">
                <ul className="mr-3 list-items">
                    <li>
                        {appointmentTotalCount > 1
                            ? t("totalAppointments") + " - " + appointmentTotalCount
                            : t("totalAppointment") + " - " + appointmentTotalCount}
                    </li>
                    <li>
                        {appointmentCount > 1
                            ? t("approvedAppointments") + " - " + appointmentCount
                            : t("approvedAppointment") + " - " + appointmentCount}
                    </li>
                    <li>
                        {appointmentRequestedCount > 1
                            ? t("pendingAppointment") + " - " + appointmentRequestedCount
                            : t("pendingAppointmentRequest") + " - " + appointmentRequestedCount}
                    </li>
                    <li>
                        {t("waitingForPatient") + " - " + appointmentPatientCount}
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default EditTimingPopupWarning;
